<template>
  <v-layout column>
    <v-flex xs12>
      <h3>Search Taxis</h3>
    </v-flex>
    <v-layout pt-2 class="search-fields" column v-on:keyup.enter="search">
      <v-select
          v-model="query.verification"
          :value="query.verification"
          :items="items"
          item-text="name"
          item-value="value"
          label="Filter By"
      ></v-select>
      <v-text-field v-model="query.search" label="Search"></v-text-field>
      <v-text-field
        type="number"
        min="4"
        v-model="query.numPassengers"
        class="small-label"
        label="Number of Seats (Min)"
      ></v-text-field>
      <v-btn @click="search" color="blue" dark class="text-none">Search</v-btn>
    </v-layout>
    <v-layout pt-3 pb-3 column>
      <v-divider />
    </v-layout>
    <v-layout column>
      <v-flex pb-3>
        <h3>Navigation</h3>
      </v-flex>
      <router-link to="/taxi/create">
        <h4>Add Taxi</h4>
      </router-link>
    </v-layout>
  </v-layout>
</template>

<script>
export default {
  name: "driver_search_box",
  props: {
    query: Object
  },
  data: function() {
    return {
      items: [
        { name: "Verification Pending", value: "verification_pending" },
        { name: "Verification Approved", value: "verification_approved" },
        { name: "Verification Rejected", value: "verification_rejected" },
        { name: "All", value: "" },
      ]
    };
  },
  methods: {
    // fromChanged: function(d) {
    //   this.query.after = d;
    // },
    // toChanged: function(d) {
    //   this.query.before = d;
    // },
    search: function() {
      this.$emit("search");
    },
    clear: function() {
      this.$emit("clear");
    }
  },
  components: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.search-fields {
  padding-left: 6px;
  padding-right: 6px;
}

.small-label .v-label {
  font-size: 14px !important;
}
</style>
